import { IToastModal } from '../interfaces/components/modal.interface';

// pass userName directly from initData instead of get from Cookie
const handleShare = (userName: string, toast: IToastModal) => {
  if (typeof window !== 'undefined') {
    const shareData = {
      title: 'Doccen.vn - Kết nối y tế Việt Nam',
      text: `Tham gia cộng đồng y tế Việt Nam cùng ${userName} tại Doccen.vn`,
      url: window.location.href,
    };
    navigator.share(shareData);
  } else {
    toast.error({
      content:
        'Không thể thực hiện tính năng này, xin vui lòng sử dụng trình duyệt được hỗ trợ',
      infinite: true,
    });
  }
};

export default handleShare;
